import * as React from 'react';
import classnames from 'classnames';
import { REPLACE_DR_PREFIX_REGEX } from 'booking/lib/constants';
import { Provider as ProviderType } from 'booking/lib/types';
import { useIntl } from 'react-intl';
import * as styles from './DateForm.module.scss';

interface ProviderProps {
    provider: ProviderType;
    selected: boolean;
    setProvider: (provider: ProviderType) => void;
    classes?: Partial<typeof styles>;
}

function Provider({
    provider,
    selected,
    setProvider,
    classes,
}: ProviderProps): JSX.Element {
    const intl = useIntl();

    if (provider && 'name' in provider && provider.name) {
        return (
            <button
                type="button"
                className={classnames({
                    [classnames(classes?.isSelected, styles.isSelected)]:
                        selected,
                })}
                onClick={() => setProvider(provider)}
            >
                <div>
                    Dr. {provider?.name?.replace(REPLACE_DR_PREFIX_REGEX, '')}
                </div>
            </button>
        );
    }

    return (
        <button
            type="button"
            className={classnames({
                [classnames(classes?.isSelected, styles.isSelected)]: selected,
            })}
            onClick={() => {
                setProvider({ state: 'any' });
            }}
        >
            <div>
                {intl.formatMessage({
                    id: 'booking.locationForm.allProviders',
                })}
            </div>
        </button>
    );
}

export default Provider;
